export default __webpack_public_path__ + "static/media/why_we_never_die.3d896874.jpg";